import { NgComponentOutlet } from '@angular/common';
import { Component, input, OnDestroy } from '@angular/core';
import { IonContent, IonHeader, IonModal, IonToolbar } from '@ionic/angular/standalone';
import { SidePanelInstance, SidePanelService } from '@services/side-panel.service';
import { fromEvent, map, startWith, Subscription } from 'rxjs';

@Component({
  imports: [
    IonContent,
    IonHeader,
    IonModal,
    IonToolbar,
    NgComponentOutlet,
  ],
  selector: 'app-side-panel-wrapper',
  styleUrls: ['./side-panel-wrapper.component.scss'],
  templateUrl: './side-panel-wrapper.component.html',
})
export class SidePanelWrapperComponent implements OnDestroy {
  readonly sidePanel = input.required<SidePanelInstance>();
  protected isDesktop = false;
  private isResizeClose = false;
  private mediaListenerCleanup?: () => void;
  private resizeSubscription?: Subscription;

  constructor(
    private sidePanelService: SidePanelService,
  ) {
    this.listenToViewport();
  }

  ngOnDestroy(): void {
    this.stopListeningToViewport();
  }

  protected close(): void {
    this.sidePanelService.close(this.sidePanel().id);
  }

  protected onBackdropClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  protected onMobileWillDismiss(): void {
    if (this.isResizeClose) {
      this.isResizeClose = false;
      return;
    }
    this.close();
  }

  private listenToViewport(): void {
    this.stopListeningToViewport();
    const matchMedia = window.matchMedia('(min-width: 768px)');
    const update = () => this.isDesktop = matchMedia.matches;
    update();
    const mediaListener = () => update();
    matchMedia.addEventListener('change', mediaListener);
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(
        startWith(null),
        map(() => matchMedia.matches),
      ).subscribe({
        next: (isDesktop) => {
          this.isResizeClose = this.isDesktop !== isDesktop;
          this.isDesktop = isDesktop;
        },
      });
    this.mediaListenerCleanup = () => matchMedia.removeEventListener('change', mediaListener);
  }

  private stopListeningToViewport(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
      this.resizeSubscription = undefined;
    }
    if (this.mediaListenerCleanup) {
      this.mediaListenerCleanup();
      this.mediaListenerCleanup = undefined;
    }
  }
}
